export default [
    {
        value: 'picking',
        title: 'Picking'
    },
    {
        value: 'boleta',
        title: 'Boleta Electrónica'
    },
    {
        value: 'factura',
        title: 'Factura Electrónica'
    },
    {
        value: 'encargo',
        title: 'Encargos'
    },
    {
        value: 'cotizacion-formal',
        title: 'Cotización Formal '
    },
    {
        value: 'guia-despacho',
        title: 'Guia Despacho'
    },
    {
        value: 'cotizacion',
        title: 'Cotización'
    },
    {
        value: 'pagoCliente',
        title: 'Pago Cliente'
    },
]
